import ModelTypeConstants from 'constants/ModelTypeConstants';

// Keep in sync with benchling/registry/trial_interfaces/domain/constants.py
export const TRIAL_SUBJECT_SCHEMA_INTERFACE_ID = 'ssi_trialsubject';
export const TRIAL_SAMPLE_SCHEMA_INTERFACE_ID = 'ssi_trialsample';

// Config required for TRIAL_SUBJECT_SCHEMA_INTERFACE_ID
export const SUBJECT_LABEL_FIELD_DISPLAY_NAME = 'Subject label';

// Config required for TRIAL_SAMPLE_SCHEMA_INTERFACE_ID
export const SAMPLE_TYPE_FIELD_DISPLAY_NAME = 'Sample type';
export const VISIT_NAME_FIELD_DISPLAY_NAME = 'Visit name';
export const SUBJECT_FIELD_DISPLAY_NAME = 'Subject';
export const TREATMENT_GROUP_FIELD_DISPLAY_NAME = 'Treatment group';
// While TrialSample is not an exclusive SSI, M3 scope is limited to custom entities.
// Eventually Trial Sample may expand to support other entity types.
// Keep consistent with benchling/registry/trial_interfaces/domain/sample_validator.py.
export const TRIAL_SAMPLE_SUPPORTED_TYPES = [ModelTypeConstants.BASIC_FOLDER_ITEM];
